// Temporary for now until we check the plugin code in.
// Tracked with Work item #46289

let fDictation: boolean = false;

export function isDictationOn() {
    return fDictation;
}

export function toggleDictation() {
    fDictation = !fDictation;
}
